import { render, staticRenderFns } from "./MoveCircleChip.vue?vue&type=template&id=b1274f60&scoped=true&"
import script from "./MoveCircleChip.vue?vue&type=script&lang=js&"
export * from "./MoveCircleChip.vue?vue&type=script&lang=js&"
import style0 from "./MoveCircleChip.vue?vue&type=style&index=0&id=b1274f60&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1274f60",
  null
  
)

export default component.exports